export interface IIssueOrgans {
  id?: number;
  uuid?: string;
  name: string;
  description: string;
}


export const issueOrgansInitValues: IIssueOrgans = {
 //id: 0,
 name: '',
 description: '',

}

